/** Defines the span type for the `type`prop of Label. */
export const TYPE_SPAN = 'span';

/** Defines the label type for the `type` prop of Label. */
export const TYPE_LABEL = 'label';

/** List of available types for the `type` prop of Label. */
export const TYPES = [TYPE_SPAN, TYPE_LABEL];
